import React, { Fragment, useState, useEffect } from 'react'
import SingleSelect from "../../common/Forms/SingleSelect";

const PackageSelect = () => {
  const [packages, setPackages] = useState([])
  const [selectedPackage, setSelectedPackage] = useState(null)

  useEffect(() => {
    const fetchPackages = async () => {
      let response = await fetch('/api/v1/orders/packages_for_export')
      response = await response.json()
      setPackages(response.data)
    }

    fetchPackages();
  }, [])

  return (
    <Fragment>
      <input name="export[package_id]"
             value={selectedPackage && selectedPackage.value}
             hidden />
      <SingleSelect
        handleChange={(data) => setSelectedPackage(data) }
        options={packages}
        selectedValue={selectedPackage}
        showCheckbox={true}
        placeholderText='Select Pricelist (do not select to download all)'
      />
    </Fragment>
  )
}

export default PackageSelect
